import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS } from 'react-admin';
import decodeJwt from 'jwt-decode';
import initDataProvider from 'utils/dataProvider';
import { buildFullAccessFor } from 'ra-auth-acl';

const dataProvider = initDataProvider();

export default () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  return (type, params) => {
    // called when the user attempts to log in
    if (type === AUTH_LOGIN) {
      const { username, password } = params;
      const request = new Request(`${apiUrl}/login`, {
        method: 'POST',
        body: JSON.stringify({ username, password }),
        headers: new Headers({ 'Content-Type': 'application/json' }),
      });
      return fetch(request)
        .then(response => {
          if (response.status < 200 || response.status >= 300) {
            throw new Error(response.statusText);
          }
          return response.json();
        })
        .then(token => {
          const decodedToken = decodeJwt(token.access_token);
          localStorage.setItem('token', JSON.stringify(token));
          localStorage.setItem('role', decodedToken.r);
        })
        .then(() => {
          const role = localStorage.getItem('role');
          return dataProvider('GET_ONE', 'roles', { id: role }).then(res => {
            if (res && res.data && typeof res.data === 'object') {
              let permissions = {};
              let p = JSON.parse(res.data.permission);
              permissions[res.data.id] = { ...buildFullAccessFor(p) };

              localStorage.setItem('permissions', JSON.stringify(permissions));
            }
          });
        });
    }
    // called when the user clicks on the logout button
    if (type === AUTH_LOGOUT) {
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      localStorage.removeItem('permissions');
      return Promise.resolve();
    }
    // called when the API returns an error
    if (type === AUTH_ERROR) {
      const { status } = params;
      if (status === 401 || status === 403) {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('permissions');
        return Promise.reject();
      }
      return Promise.resolve();
    }
    // called when the user navigates to a new location
    if (type === AUTH_CHECK) {
      return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
    }
    if (type === AUTH_GET_PERMISSIONS) {
      const role = localStorage.getItem('role');
      const permissions = JSON.parse(localStorage.getItem('permissions'));

      return role ? Promise.resolve(permissions[role]) : Promise.reject();
    }
    return Promise.reject('Unknown method');
  };
};



// WEBPACK FOOTER //
// ./src/utils/authProvider.js